import React, { useState } from "react";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import "./css/index.css";

export const FAQSection = () => {
  const faqs = [
    {
      question: "Can I export my palette to CSS?",
      answer:
        "Yes! You can copy your palette as CSS variables and use them directly in your stylesheets."
    },
    {
      question: "Is it Free?",
      answer:
        "Yes! It is absolutely free and requires no signup"
    },
    {
  question: "How do I generate a new palette?",
  answer: "To generate a new color palette, simply press the spacebar on your keyboard while viewing the generator. Each press instantly creates a fresh, harmonious palette."
},
    {
      question: "Does it support Tailwind CSS?",
      answer:
        "Absolutely! You can export your colors as Tailwind v3/v4 config or @theme variables."
    },
    {
      question: "Can I generate social media images?",
      answer:
        "Yes, PNG and SVG exports are ready for sharing on social platforms or including in presentations."
    },
    {
      question: "Is there a limit to the number of palettes I can save?",
      answer:
        "No limits! You can lock and generate as many palettes as you like during your session."
    }
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-header">
        <h2>Frequently Asked Questions</h2>
        <p>Everything you need to know about using WorldPaint.</p>
      </div>

      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${openIndex === index ? "open" : ""}`}
          >
            <button
              className="faq-question"
              onClick={() => toggleFAQ(index)}
            >
              {faq.question}
              {openIndex === index ? (
                <BiChevronUp className="faq-icon" />
              ) : (
                <BiChevronDown className="faq-icon" />
              )}
            </button>
            {openIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};